<ng-container *transloco="let t">
  <div class="space-y-5">
    <h6 *ngIf="!isCustomDomain">{{ t('settings.preferences.customDomain.connectTitle') }}</h6>
    <div class="grid grid-cols-12 gap-4" *ngIf="!isCustomDomain">
      <div class="col-span-8">
        <div class="flex flex-row gap-4">
          <nz-form-item class="w-full m-0">
            <nz-form-label
              nzRequired
              nzFor="customDomain"
            >
              {{ t('settings.preferences.customDomain.form.domainLabel') }}
            </nz-form-label>
            <nz-form-control
              [nzValidateStatus]="customDomain && !isValidCustomDomain(customDomain) ? 'error' : ''"
              [nzErrorTip]="customDomainErrorTpl">
              <input
                type="text"
                nz-input
                [(ngModel)]="customDomain"
                [placeholder]="t('settings.preferences.customDomain.form.domainPlaceholder')"/>
            </nz-form-control>
            <ng-template #customDomainErrorTpl>
              <div class="space-y-0.5">
                <div *ngIf="customDomain.includes('www.')">{{ t('settings.preferences.customDomain.validation.removeWww') }}</div>
                <div *ngIf="customDomain.includes('/') || customDomain.includes('\\')">{{ t('settings.preferences.customDomain.validation.removeSlashes') }}</div>
                <div *ngIf="customDomain && customDomain.match('[^a-zA-Z0-9.@-]')">{{ t('settings.preferences.customDomain.validation.removeSpecialSymbols') }}</div>
                <div *ngIf="customDomain && !isValidCustomDomain(customDomain)">{{ t('settings.preferences.customDomain.validation.invalidDomain') }}</div>
              </div>
            </ng-template>
          </nz-form-item>
          <button
            nz-button
            nzType="primary"
            [disabled]="!customDomain || !isValidCustomDomain(customDomain)"
            (click)="onClickDomain()"
            class="flex items-center justify-center gap-2">
            <lucide-icon name="plus" class="icon-size"></lucide-icon>
            {{ t('settings.preferences.customDomain.actions.connect') }}
          </button>
        </div>
      </div>
      <div class="col-span-8">
        <nz-alert
          nzType="info"
          nzShowIcon
          [nzMessage]="t('settings.preferences.customDomain.info.domainFormat')"
        ></nz-alert>
      </div>
    </div>

    <div *ngIf="isCustomDomain">
      <h6>{{ t('settings.preferences.customDomain.dns.title') }}</h6>
      <nz-alert
        class="mt-2"
        nzType="warning"
        [nzMessage]="t('settings.preferences.customDomain.dns.warning')">
      </nz-alert>
    </div>

    <div *ngIf="isCustomDomain">
      <div class="mb-2">
        <h6>{{ t('settings.preferences.customDomain.configuredTo') }} <strong>{{ customDomainData.hostname }}</strong></h6>
      </div>
      <nz-table
        #customDomainTable
        [nzData]="customDomainData ? [customDomainData] : []"
        [nzShowPagination]="false"
        [nzBordered]="true"
        nzSize="small"
      >
        <thead>
          <tr>
            <th>{{ t('settings.preferences.customDomain.table.field') }}</th>
            <th>{{ t('settings.preferences.customDomain.table.value') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ t('settings.preferences.customDomain.table.status') }}</td>
            <td>
              <nz-tag *ngIf="customDomainData?.status" [nzColor]="statusColors(customDomainData?.status)">
                {{ customDomainData?.status | titlecase }}
              </nz-tag>
              <span *ngIf="!customDomainData?.status">-</span>
            </td>
          </tr>
          <tr>
            <td>{{ t('settings.preferences.customDomain.table.sslStatus') }}</td>
            <td>
              <nz-tag *ngIf="customDomainData?.sslStatus" [nzColor]="statusColorsSsl(customDomainData?.sslStatus)">
                {{ customDomainData?.sslStatus | titlecase }}
              </nz-tag>
              <span *ngIf="!customDomainData?.sslStatus">-</span>
            </td>
          </tr>
          <tr>
            <td>{{ t('settings.preferences.customDomain.table.cname') }}</td>
            <td>
              <div class="flex flex-col gap-1">
                <span class="flex items-center gap-2">
                  <span class="text-gray-500">{{ t('settings.preferences.customDomain.table.name') }}:</span>
                  {{ customDomainData?.hostname?.split('.')[0] }}
                  <lucide-icon
                    name="copy"
                    class="icon-size cursor-pointer text-gray-900 hover:text-primary"
                    nz-tooltip
                    [nzTooltipTitle]="t('settings.preferences.customDomain.actions.copy')"
                    (click)="copyToClipboard(customDomainData?.hostname?.split('.')[0])">
                  </lucide-icon>
                </span>
                <span *ngIf="customDomainData?.preValidationTxtValue" class="flex items-center gap-2">
                  <span class="text-gray-500">{{ t('settings.preferences.customDomain.table.value') }}:</span>
                  {{ removeProtocol(environment.previewLink) }}
                  <lucide-icon
                    name="copy"
                    class="icon-size cursor-pointer text-gray-900 hover:text-primary"
                    nz-tooltip
                    [nzTooltipTitle]="t('settings.preferences.customDomain.actions.copy')"
                    (click)="copyToClipboard(removeProtocol(environment.previewLink))">
                  </lucide-icon>
                </span>
              </div>
            </td>
          </tr>
          <tr>
            <td>{{ t('settings.preferences.customDomain.table.preValidationTxt') }}</td>
            <td>
              <div class="flex flex-col gap-1">
                <span *ngIf="customDomainData?.preValidationTxtName" class="flex items-center gap-2">
                  <span class="text-gray-500">{{ t('settings.preferences.customDomain.table.name') }}:</span>
                  {{ customDomainData?.preValidationTxtName }}
                  <lucide-icon
                    name="copy"
                    class="icon-size cursor-pointer text-gray-900 hover:text-primary"
                    nz-tooltip
                    [nzTooltipTitle]="t('settings.preferences.customDomain.actions.copy')"
                    (click)="copyToClipboard(customDomainData?.preValidationTxtName)">
                  </lucide-icon>
                </span>
                <span *ngIf="!customDomainData?.preValidationTxtName">
                  <span class="text-gray-500">{{ t('settings.preferences.customDomain.table.name') }}:</span>
                  {{ t('settings.preferences.customDomain.table.pending') }}
                </span>
                <span *ngIf="customDomainData?.preValidationTxtValue" class="flex items-center gap-2">
                  <span class="text-gray-500">{{ t('settings.preferences.customDomain.table.value') }}:</span>
                  {{ customDomainData?.preValidationTxtValue }}
                  <lucide-icon
                    name="copy"
                    class="icon-size cursor-pointer text-gray-900 hover:text-primary"
                    nz-tooltip
                    [nzTooltipTitle]="t('settings.preferences.customDomain.actions.copy')"
                    (click)="copyToClipboard(customDomainData?.preValidationTxtValue)">
                  </lucide-icon>
                </span>
                <span *ngIf="!customDomainData?.preValidationTxtValue">
                  <span class="text-gray-500">{{ t('settings.preferences.customDomain.table.value') }}:</span>
                  {{ t('settings.preferences.customDomain.table.pending') }}
                </span>
              </div>
            </td>
          </tr>
          <tr>
            <td>{{ t('settings.preferences.customDomain.table.certificateTxt') }}</td>
            <td>
              <div class="flex flex-col gap-1">
                <span *ngIf="customDomainData?.certificateValidationTxtName" class="flex items-center gap-2">
                  <span class="text-gray-500">{{ t('settings.preferences.customDomain.table.name') }}:</span>
                  {{ customDomainData?.certificateValidationTxtName }}
                  <lucide-icon
                    name="copy"
                    class="icon-size cursor-pointer text-gray-900 hover:text-primary"
                    nz-tooltip
                    [nzTooltipTitle]="t('settings.preferences.customDomain.actions.copy')"
                    (click)="copyToClipboard(customDomainData?.certificateValidationTxtName)">
                  </lucide-icon>
                </span>
                <span *ngIf="!customDomainData?.certificateValidationTxtName">
                  <span class="text-gray-500">{{ t('settings.preferences.customDomain.table.name') }}:</span>
                  {{ t('settings.preferences.customDomain.table.pending') }}
                </span>
                <span *ngIf="customDomainData?.certificateValidationTxtValue" class="flex items-center gap-2">
                  <span class="text-gray-500">{{ t('settings.preferences.customDomain.table.value') }}:</span>
                  {{ customDomainData?.certificateValidationTxtValue }}
                  <lucide-icon
                    name="copy"
                    class="icon-size cursor-pointer text-gray-900 hover:text-primary"
                    nz-tooltip
                    [nzTooltipTitle]="t('settings.preferences.customDomain.actions.copy')"
                    (click)="copyToClipboard(customDomainData?.certificateValidationTxtValue)">
                  </lucide-icon>
                </span>
                <span *ngIf="!customDomainData?.certificateValidationTxtValue">
                  <span class="text-gray-500">{{ t('settings.preferences.customDomain.table.value') }}:</span>
                  {{ t('settings.preferences.customDomain.table.pending') }}
                </span>
              </div>
            </td>
          </tr>
          <tr>
            <td>{{ t('settings.preferences.customDomain.table.createdAt') }}</td>
            <td>{{ customDomainData?.createdAt | date: 'medium' }}</td>
          </tr>
          <tr>
            <td>{{ t('settings.preferences.customDomain.table.updatedAt') }}</td>
            <td>{{ customDomainData?.updatedAt | date: 'medium' }}</td>
          </tr>
        </tbody>
      </nz-table>

      <div class="flex gap-5 my-4 justify-end">
        <button
          nz-button
          nzType="default"
          (click)="removeCustomDomain()"
          class="flex items-center justify-center gap-2">
          <lucide-icon name="trash-2" class="icon-size"></lucide-icon>
          {{ t('settings.preferences.customDomain.actions.removeDomain') }}
        </button>
        <button
          nz-button
          nzType="primary"
          (click)="getCustomHostnameInfo()"
          class="flex items-center justify-center gap-2">
          <lucide-icon name="refresh-cw" class="icon-size"></lucide-icon>
          {{ t('settings.preferences.customDomain.actions.refresh') }}
        </button>
      </div>
    </div>
  </div>
</ng-container>
